import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { preloadAssets } from '@/lib/assetCache'
import { preloadAllMascotAnimations } from '@/utils/mascotCache'

const MIC_ASSETS = ['/mic-start.png', '/mic-stop.png']

const LIGHT_ASSETS = [
  '/us-flag.png',
  '/thai-flag.png',
  '/logo.webp',
  '/favicon/favicon-32x32.png',
]

function needsSpeechAssets(pathname: string): boolean {
  return (
    pathname.startsWith('/lessons') ||
    pathname.startsWith('/student') ||
    pathname.startsWith('/evaluation')
  )
}

function scheduleIdle(fn: () => void): void {
  const ric = (window as Window & {
    requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number
  }).requestIdleCallback
  if (typeof ric === 'function') {
    ric(fn, { timeout: 4000 })
  } else {
    window.setTimeout(fn, 1500)
  }
}

/**
 * Preload mascots/mic on lesson/student/eval routes immediately;
 * otherwise defer via requestIdleCallback so `/` stays light.
 */
export function AssetPreloader() {
  const { pathname } = useLocation()

  useEffect(() => {
    const preloadSpeechAssets = () => {
      preloadAllMascotAnimations().catch((error) => {
        console.warn('Failed to preload mascot animations:', error)
      })
      preloadAssets(MIC_ASSETS).catch((error) => {
        console.warn('Failed to preload mic assets:', error)
      })
    }

    if (needsSpeechAssets(pathname)) {
      preloadSpeechAssets()
    } else {
      scheduleIdle(preloadSpeechAssets)
    }

    // Small UI chrome — idle on home, fine elsewhere after a tick
    scheduleIdle(() => {
      preloadAssets(LIGHT_ASSETS).catch((error) => {
        console.warn('Failed to preload some assets:', error)
      })
    })
  }, [pathname])

  return null
}
